import React from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import Stack from '@mui/material/Stack';

interface SharedDetailAccordionProps {
  index: string;
  title: string;
  detail?: React.ReactNode;
  subDetail?: React.ReactNode;
  expanded?: boolean;
  onChange?: (
    event: React.SyntheticEvent<Element, Event>,
    expanded: boolean
  ) => void;
}

export default function SharedDetailAccordionNew({
  index,
  title,
  detail,
  subDetail,
  expanded,
  onChange,
}: SharedDetailAccordionProps) {
  const theme = useTheme();

  return (
    <Accordion
      key={index}
      disableGutters
      elevation={0}
      sx={{
        width: '100%',
        borderRadius: 1,
        backgroundColor: theme.palette.semantic.surface.bg1,
        borderColor: theme.palette.semantic.outline.light,
      }}
      expanded={expanded}
      onChange={onChange}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        sx={{
          minHeight: '48px !important',
          backgroundColor: 'transparent',
          p: 2,
        }}
      >
        <Typography
          variant="body2"
          sx={{ fontWeight: 600, color: theme.palette.text.primary }}
        >
          {title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails
        sx={{
          px: 0,
          py: 2,
          borderTop: '1px solid',
          borderTopColor: theme.palette.semantic.outline.light,
        }}
      >
        <Stack spacing={1.5} sx={{ display: 'inline-block', width: '100%' }}>
          {detail ? detail : null}
          {subDetail ? subDetail : null}
        </Stack>
      </AccordionDetails>
    </Accordion>
  );
}
